import React, { useEffect, useState } from 'react'
import { Input } from '../../components/ui/input'
import { Separator } from '../../components/ui/separator'
import {
    Table,
    TableBody,
    TableCaption,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from "../../components/ui/table"
import {
    Pagination,
    PaginationContent,
    PaginationEllipsis,
    PaginationItem,
    PaginationLink,
    PaginationNext,
    PaginationPrevious,
} from "../../components/ui/pagination"
import axios from 'axios'

const token = localStorage.getItem("adminToken")
const User = () => { 
    const [users, setUsers] = useState([])
    const [search, setSearch] = useState("")
    const [statusFilter, setStatusFilter] = useState("all") // 'all', 'active', 'inactive'
    console.log("users : " , users)
    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const res = await axios.get("https://wavetechservices.in/api/admin/users", {
                    headers: {
                        "Authorization": `Bearer ${token}`
                    }
                })
                setUsers(res.data.data)
            } catch (err) {
                console.error(err, "error")
            }
        }
        fetchUsers()
    }, []) 

    const toggleUserStatus = async (userId, currentStatus) => {
        try {
            const updatedStatus = currentStatus === "active" ? "inactive" : "active";
            console.log(userId, updatedStatus, "userId, currentStatus")

            setUsers((prevUsers) =>
                prevUsers.map((user) =>
                    user._id === userId ? { ...user, accountStatus: updatedStatus } : user
                )
            );

            await axios.put(
                `https://wavetechservices.in/api/admin/services/user-status`,
                { userId, status: updatedStatus },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
        } catch (error) {
            console.error("Error updating user status:", error);
        }
    };
 
    const filteredUsers = users.filter(user => {
        const matchesSearch = user.customerName?.toLowerCase().includes(search?.toLowerCase())
        const matchesStatus = statusFilter === "all" || user.accountStatus === statusFilter
        return matchesSearch && matchesStatus
    });
 
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 5;
     
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentServices = filteredUsers.slice(indexOfFirstItem, indexOfLastItem);
    
    const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);
    const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);
    
    const maxVisiblePages = 10;
    const startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    const endPage = Math.min(totalPages, startPage + maxVisiblePages - 1)
  
    return (
        <div className='px-[1vw] my-5'>
            <div className='flex lg:justify-between lg:items-center flex-col lg:flex-row '>
                <h1 className='text-2xl'>Registered Customer</h1>
                <div className='flex lg:gap-4 items-center gap-2 my-3 lg:my-0'>
                    <Input
                        type="text"
                        placeholder="Search"
                        className="border p-2 rounded-md w-full"
                        value={search}
                        onChange={(e) => {
                            setSearch(e.target.value)
                            setCurrentPage(1) // Reset to first page when searching
                        }}
                    />
                    <select
                        className="border p-2 rounded-md"
                        value={statusFilter}
                        onChange={(e) => {
                            setStatusFilter(e.target.value)
                            setCurrentPage(1) // Reset to first page when changing filter
                        }}
                    >
                        <option value="all">All Users</option>
                        <option value="active">Active Users</option>
                        <option value="inactive">Inactive Users</option>
                    </select>
                </div>
            </div>
            <Separator className='my-4' />

            <div className='overflow-x-auto lg:max-w-[1000px] max-w-[380px] md:max-w-[580px] lg:h-[65vh] h-[58vh] md:h-[70vh]'>
                <Table>
                    <TableHeader>
                        <TableRow>
                            <TableHead className='truncate'>Sl No.</TableHead>
                            <TableHead className="truncate">Customer Name</TableHead>
                            <TableHead className="truncate">Phone No</TableHead>
                            <TableHead className='w-[300px]'>Email</TableHead>
                            <TableHead>Address</TableHead>
                            <TableHead>No of Booking</TableHead>
                            <TableHead>Account Status</TableHead>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {currentServices.length > 0 ? (
                            currentServices.map((user, ind) => {
                                return (
                                    <TableRow key={user._id}>
                                        <TableCell>{indexOfFirstItem + ind + 1}.</TableCell>
                                        <TableCell>{user.customerName}</TableCell>
                                        <TableCell>{user.phoneNo}</TableCell>
                                        <TableCell className='w-[400px]'>{user.email}</TableCell>
                                        <TableCell className='w-[400px]'>Bengaluru</TableCell>
                                        <TableCell className='w-[400px]'>{user.noOfBookings}</TableCell>
                                        <TableCell className='w-[400px]'>
                                            <button
                                                className={`px-4 py-2 rounded-md text-white font-semibold transition-all duration-300 ${
                                                    user.accountStatus === "active"
                                                        ? "bg-red-500 hover:bg-red-600"
                                                        : "bg-green-500 hover:bg-green-600"
                                                }`}
                                                onClick={() => toggleUserStatus(user._id, user.accountStatus)}
                                            >
                                                {user.accountStatus === "active" ? "Deactivate" : "Activate"}
                                            </button>
                                        </TableCell>
                                    </TableRow>
                                )
                            })
                        ) : (
                            <TableRow>
                                <TableCell colSpan={7} className="text-center py-4">
                                    No users found
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </div>

            {filteredUsers.length > 0 && (
                <div>
                    <Pagination className="mt-4">
                        <PaginationContent>
                            {currentPage > 1 && (
                                <PaginationItem>
                                    <PaginationPrevious onClick={() => handlePageChange(currentPage - 1)} />
                                </PaginationItem>
                            )}
            
                            {startPage > 1 && (
                                <>
                                    <PaginationItem>
                                        <PaginationLink onClick={() => handlePageChange(1)}>1</PaginationLink>
                                    </PaginationItem>
                                    {startPage > 2 && <PaginationItem><span>...</span></PaginationItem>}
                                </>
                            )}
            
                            {[...Array(endPage - startPage + 1)].map((_, index) => {
                                const pageNumber = startPage + index;
                                return (
                                    <PaginationItem key={pageNumber}>
                                        <PaginationLink
                                            isActive={pageNumber === currentPage}
                                            onClick={() => handlePageChange(pageNumber)}
                                        >
                                            {pageNumber}
                                        </PaginationLink>
                                    </PaginationItem>
                                );
                            })}
            
                            {endPage < totalPages && (
                                <>
                                    {endPage < totalPages - 1 && <PaginationItem><span>...</span></PaginationItem>}
                                    <PaginationItem>
                                        <PaginationLink onClick={() => handlePageChange(totalPages)}>{totalPages}</PaginationLink>
                                    </PaginationItem>
                                </>
                            )}
            
                            {currentPage < totalPages && (
                                <PaginationItem>
                                    <PaginationNext onClick={() => handlePageChange(currentPage + 1)} />
                                </PaginationItem>
                            )}
                        </PaginationContent>
                    </Pagination>
                </div>
            )}
        </div>
    )
}

export default User